<template>
  <el-drawer
    :withHeader="false"
    :visible.sync="modelValue"
    :direction="direction"
    custom-class="model-relic-dialog"
    :modal="false"
    :size="size"
  >
    <model-relic-dialog-header-vue
      @onCloseClick="handleCloseClick"
      @onChangeClick="handleChangeClick"
      :relicName="relicName"
      v-model="isActive"
      :relicInfo="relicInfo"
    />
    <div
      class="dialog-tab"
      :style="size == '480px' ? '' : 'height:calc(100vh - 100px)'"
    >
      <model-relic-dialog-info-vue
        :relicInfo="relicInfo"
        v-show="isActive === 1"
        :visibleSize="visibleSize"
      />
      <model-point-cloud-vue :relicInfo="relicInfo" v-show="isActive === 2" />
      <model-relic-swiper-vue
        v-show="isActive === 3"
        :photos="drawings"
        :visibleSize="visibleSize"
      />
      <model-relic-swiper-vue
        v-show="isActive === 4"
        :photos="photos"
        :visibleSize="visibleSize"
      />
    </div>
  </el-drawer>
</template>

<script>
import { mixinModel } from '../assets/js/model';
import modelPointCloudVue from './model-point-cloud.vue';
import modelRelicDialogHeaderVue from './model-relic-dialog-header.vue';
import modelRelicDialogInfoVue from './model-relic-dialog-info.vue';
import modelRelicSwiperVue from './model-relic-swiper.vue';
export default {
  mixins: [mixinModel],
  props: {
    relicDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    photos() {
      return this.relicDetail?.realisticPic;
    },
    drawings() {
      return this.relicDetail?.draw;
    },
    relicInfo() {
      return this.relicDetail;
    },
    relicName() {
      return this.relicDetail?.name;
    },
    visibleSize() {
      return this.size == '480px';
    }
  },
  watch: {
    // relicDetail: {
    //   immediate: true,
    //   handler(newValue) {
    //     const visibleSort = newValue?.drawings.every(item => {
    //       return item.drawingId;
    //     });
    //     if (visibleSort) {
    //       this.drawings = newValue?.drawings.sort(compare('drawingId'));
    //     }
    //   }
    // },
    modelValue(newValue) {
      newValue ? this.isActive : (this.isActive = 1);
    }
  },
  components: {
    modelRelicDialogHeaderVue,
    modelRelicDialogInfoVue,
    modelPointCloudVue,
    modelRelicSwiperVue
  },
  data() {
    return {
      drawer: false,
      direction: 'btt',
      size: '480px',
      isActive: 1
    };
  },
  methods: {
    handleCloseClick() {
      this.modelValue = false;
    },
    handleChangeClick() {
      this.size = this.size == '480px' ? '100%' : '480px';
    }
  }
};
</script>

<style lang="scss">
.model-relic-dialog {
  background-color: #0d1518;
  .dialog-tab {
    height: 380px;
  }
}
</style>
